export function getFilteredImages(images, selectedColor) {
  if (!Array.isArray(images)) return []

  const hasColorInfo = images.some(img => img.color_id !== null)

  if (!hasColorInfo) {
    return images
  }

  if (selectedColor) {
    return images.filter(img => img.color_name === selectedColor)
  }

  return images.length > 0 ? [images[0]] : []
}
